import {CalendarOutlined, InboxOutlined} from '@ant-design/icons';
import {Button} from 'antd';

const MeetingArchiveToggle = ({showArchived, onChange}) => (
  <Button
    icon={showArchived ? <CalendarOutlined/> : <InboxOutlined/>}
    onClick={() => onChange(!showArchived)}
  >
    {showArchived ? 'Aktive Tagungen anzeigen' : 'Archivierte Tagungen anzeigen'}
  </Button>
);

export default MeetingArchiveToggle;
